import { Box, Flex, Image } from '@gassan-ui'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { Button, Heading } from '@rolex-ui'
import { rem } from 'polished'
import React, { FC } from 'react'
import styled from 'styled-components'
import { MarginProps } from 'styled-system'

const ImageParent = styled(Box)`
  &:after {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    content: '';
    display: block;
  }
`

type Props = MarginProps & {
  image: AssetsElement
  preTitle: string
  title: string
  href: string
  buttonTitle: string
}

const PushBanner: FC<Props> = ({ image, preTitle, title, href, buttonTitle, m = '10vh 0' }) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      height="40vh"
      position="relative"
      m={m}
    >
      <ImageParent position="absolute" top="0" left="0" height="100%" width="100%" zIndex={-1}>
        <Image
          zIndex={-1}
          placeholder={getKontentImage(image.value[0].url, { width: 50 })}
          sources={[
            getKontentImage(image.value[0].url, { width: 600 }),
            getKontentImage(image.value[0].url, { width: 1000 }),
            getKontentImage(image.value[0].url, { width: 1500 }),
            getKontentImage(image.value[0].url, { width: 1920 })
          ]}
          alt={image.value[0].description}
          height="100%"
          width="100%"
        />
      </ImageParent>
      <Box>
        <Heading variant="verySmallTitle" mb={rem(20)} color="white">
          {preTitle}
        </Heading>
        <Heading variant="largeTitle" mb={rem(20)} color="white">
          {title}
        </Heading>
        <Button as="link" variant="tertiary" href={href}>
          {buttonTitle}
        </Button>
      </Box>
    </Flex>
  )
}

export default PushBanner
